<div class="innerPagesBlock">
  <app-side-menu></app-side-menu>
  <div class="admin-panel" *ngIf="!loading; else loader">
    <!-- <app-banner-footer-pages [title]="title1"></app-banner-footer-pages> -->

    <div *ngIf="ispageLoading">
      <div class="reasons">
        <div class="row align-items-center justify-content-start">
          <div class="col-md-4">
            <div  (click)="goBack()">
              <img src="../../../assets/images/back_btn.svg" alt="" /> <span class="bck_btn px-2">Back</span>
            </div>
          </div>
          <div class="col-md-8">
            <div class="reasons-head pl-5">{{currentStatusName}}</div>
          </div>
        </div>
        <!-- <div class="reasons-head">{{currentStatus?.fromStatus }}</div> -->
        <!-- <h3 class="reason">Reasons</h3>
        <ol type="1">
          <li>
            Lorem ipsum dolor sit amet consectetur.
          </li>
          <li>
            In elit sem pellentesque morbi adipiscing urna malesuada proin.
          </li>
          <li>
            A dictumst non nulla a enim arcu non.
          </li>
          <li>
            Velit cursus tristique netus odio bibendum blandit. Justo commodo dignissim est vitae.
          </li>
        </ol> -->
      </div>
    </div>
    <div *ngIf="ispageLoading" class="documentsPageFormSec">
      <app-main-heading [title]="title"></app-main-heading>
      <form [formGroup]="myForm">
        <div class="innerpageContent validationdetailspage">
          <div class="row">
            <div class="col-lg-6">
              <div class="inputGroup">
                <div class="inputGroupInput">
                  <select name="pre" id="pre" class="regSelect" formControlName="salutationId">
                    <option [ngValue]="2">Miss</option>
                    <option [ngValue]="1">Mrs</option>
                  </select>
                  <div class="inputGroupInner">
                    <input onkeydown="return /[a-z ]/i.test(event.key)" formControlName="firstName" type="text"
                      id="firstName" class="inputBox" placeholder="" />
                    <label for="firstName" class="inputLabel">First Name</label>
                  </div>
                </div>
                <!-- <span class="passError" *ngIf="
                  myForm.get('firstName') &&
                  myForm.get('firstName').invalid &&
                  myForm.get('firstName').touched
                ">Please Enter First Name</span> -->
                <span class="passError" *ngIf="
                    myForm.get('salutationId').invalid &&
                    myForm.get('firstName').valid
                  ">Please select title</span>
                <span class="passError" *ngIf="myForm.get('firstName').invalid">Please fill first name</span>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="inputGroup">
                <input onkeydown="return /[a-z ]/i.test(event.key)" type="text" formControlName="lastName"
                  class="inputBox" id="lastName" placeholder="" />
                <label for="lastName" class="inputLabel">Last Name</label>
                <span class="passError" *ngIf="myForm.get('lastName').invalid">Please fill first name</span>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="inputGroup">
                <input type="email" formControlName="emailId" class="inputBox" id="emailId" inputmode="email"
                  placeholder="" />
                <label for="emailId" class="inputLabel">Email ID</label>
                <span class="passError" *ngIf="
                    myForm.get('emailId').invalid &&
                    myForm.get('emailId').value == ''
                  ">Please fill email id</span>
                <span class="passError" *ngIf="
                    myForm.get('emailId').invalid &&
                    myForm.get('emailId').value != ''
                  ">Email is not valid</span>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="inputGroup">
                <div class="inputGroupInput">
                  <input [disabled]="true" name="CountryCode" id="countryCode" type="text" value="+91"
                    class="pre-input" />

                  <div class="inputGroupInner">
                    <input formControlName="contactNumber" type="tel" maxlength="10" class="inputBox" id="mobile"
                      maxlength="10" (keypress)="numberOnly($event)" (paste)="this.handlePasteNumber($event)"
                      placeholder="" />
                    <label for="mobile" class="inputLabel">Mobile Number
                    </label>
                  </div>
                </div>
              </div>
              <span class="passError" *ngIf="
                  myForm.get('contactNumber').invalid &&
                  myForm.get('contactNumber').value == ''
                ">Please fill mobile number</span>
              <span class="passError" *ngIf="
                  myForm.get('contactNumber').invalid &&
                  myForm.get('contactNumber').value != ''
                ">Mobile number is not valid</span>
            </div>
            <div class="col-lg-6">
              <div class="inputGroup">
                <mat-form-field class="w-100 mat-input-group" appearance="outline">
                  <mat-label class="matLabel">Education Qualification</mat-label>
                  <mat-select formControlName="eduQualificationId">
                    <mat-option [value]="qualification.id" *ngFor="let qualification of qualificationList">{{
                      qualification.name }}</mat-option>
                  </mat-select>
                  <mat-error  class="passError" *ngIf="myForm.get('eduQualificationId').invalid && myForm.get('eduQualificationId').touched">
                    Please Select Education Qualification
                  </mat-error>
                </mat-form-field>
                <!-- <span class="passError">Please Select Education Qualification</span> -->
              </div>
            </div>
            <div class="col-lg-6">
              <div class="inputGroup">
                <mat-form-field class="w-100 mat-input-group" appearance="outline">
                  <input matInput [readonly]="true" [matDatepicker]="picker" (click)="picker.open()"
                    [max]="getMinDate()" placeholder=" " id="dob" formControlName="dateOfBirth" max />
                  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-datepicker #picker startView="year"></mat-datepicker>
                </mat-form-field>
                <label for="dob" class="inputLabel">Date of Birth</label>
              </div>
              <span class="passError" *ngIf="getValid('dateOfBirth')">Please Select Date Of Birth</span>
            </div>
            <div class="col-lg-6">
              <div class="inputGroup">
                <input type="text" formControlName="businessEmailId"
                  class="inputBox" id="BusinessEmail" placeholder="" />
                <label for="BusinessEmail" class="inputLabel">Business Email ID</label>
              </div>
              <!-- <span class="passError" *ngIf="
                  myForm.get('businessEmailId').invalid &&
                  myForm.get('businessEmailId').value == ''
                ">Please fill business email id</span> -->
              <span class="passError" *ngIf="
                  myForm.get('businessEmailId').invalid &&
                  myForm.get('businessEmailId').value != ''
                ">Business email is not valid</span>
            </div>
            <div class="col-lg-6">
              <div class="inputGroup">
                <input  type="text" formControlName="custSupportEmailId"
                  class="inputBox" id="CustomerEmail" inputmode="email" placeholder="" />
                <label for="CustomerEmail" class="inputLabel">Customer Support Email ID</label>
              </div>
              <!-- <span class="passError" *ngIf="
                  myForm.get('custSupportEmailId').invalid &&
                  myForm.get('custSupportEmailId').value == ''
                ">Please fill customer support email id</span> -->
                  <span class="passError" *ngIf="
                  myForm.get('custSupportEmailId').invalid &&
                  myForm.get('custSupportEmailId').value != ''
                ">Customer support email is not valid</span>
            </div>
            <div class="col-lg-6">
              <div class="inputGroup">
                <div class="inputGroupInput">
                  <input [disabled]="true" name="businessCountryCode" id="businessCountryCode" type="text" value="+91"
                    class="pre-input" />

                  <div class="inputGroupInner">
                    <input formControlName="businessNumber" type="tel" maxlength="10" minlength="10" class="inputBox"
                      inputmode="numeric" id="Businessmobile" placeholder="" (keypress)="numberOnly($event)"
                      (paste)="this.handlePasteNumber($event)" />
                    <label for="Businessmobile" class="inputLabel">Business Number</label>
                  </div>
                </div>
              </div>
              <!-- <span class="passError" *ngIf="
                  myForm.get('businessNumber').invalid &&
                  myForm.get('businessNumber').value == ''
                ">Please fill business number</span> -->
               <span class="passError" *ngIf="
                  myForm.get('businessNumber').invalid &&
                  myForm.get('businessNumber').value != ''
                ">Business number is not valid</span>
            </div>
            <div class="col-lg-6">
              <div class="inputGroup">
                <div class="inputGroupInput">
                  <input [disabled]="true" name="customerCountryCode" id="customerCountryCode" type="text" value="+91"
                    class="pre-input" />

                  <div class="inputGroupInner">
                    <input formControlName="custSupportNo" type="tel" maxlength="10" minlength="10" inputmode="numeric"
                      class="inputBox" id="CustomerSupportmobile" placeholder="" (keypress)="numberOnly($event)"
                      (paste)="this.handlePasteNumber($event)" />
                    <label for="CustomerSupportmobile" class="inputLabel">Customer Support Number</label>
                  </div>
                </div>
              </div>
              <span class="passError" *ngIf="
                  myForm.get('custSupportNo').invalid &&
                  myForm.get('custSupportNo').value == ''
                ">Please fill customer support number</span>
              <span class="passError" *ngIf="
                  myForm.get('custSupportNo').invalid &&
                  myForm.get('custSupportNo').value != ''
                ">Customer support number is not valid</span>
            </div>
            <div class="col-lg-6">
              <div class="inputGroup">
                <div class="inputGroupInput">
                  <input [disabled]="true" name="countryCodeWhatsappNumber" id="countryCodeWhatsappNumber" type="text"
                    value="+91" class="pre-input" />

                  <div class="inputGroupInner">
                    <input formControlName="whatsappNumber" type="text" maxlength="10" minlength="10"
                      inputmode="numeric" class="inputBox" id="WhatsAppmobile" placeholder=""
                      (keypress)="numberOnly($event)" (paste)="this.handlePasteNumber($event)" />
                    <label for="WhatsAppmobile" class="inputLabel">WhatsApp Number</label>
                  </div>
                </div>
              </div>
              <!-- <span class="passError" *ngIf="
                  myForm.get('whatsappNumber').invalid &&
                  myForm.get('whatsappNumber').value == ''
                ">Please fill whatsapp number</span> -->
               <span class="passError" *ngIf="
                  myForm.get('whatsappNumber').invalid &&
                  myForm.get('whatsappNumber').value != ''
                ">Whatsapp number is not valid</span>
            </div>
            <div class="col-lg-6">
              <div class="inputGroup">
                <input type="url" formControlName="websiteURL" class="inputBox" id="WebURL" placeholder="" />
                <label for="WebURL" class="inputLabel">Website URL</label>
              </div>
              <!-- <span class="passError" *ngIf="
                  myForm.get('websiteURL').invalid &&
                  myForm.get('websiteURL').value == ''
                ">Website url is required
              </span> -->
               <span class="passError" *ngIf="
                  myForm.get('websiteURL').invalid &&
                  myForm.get('websiteURL').value != ''
                ">Website url is not valid
              </span>
            </div>
            <div class="col-lg-6">
              <div class="inputGroup">
                <input (keypress)="numberOnly($event)" type="text" formControlName="pincode" maxlength="6"
                  class="inputBox" id="pincode" placeholder="" (paste)="this.handlePasteNumber($event)"
                  (input)="pincodeInfoGet($event.target)" />
                <label for="pincode" class="inputLabel">Pincode</label>
              </div>
              <span class="passError" *ngIf="
                  myForm.get('pincode').invalid &&
                  myForm.get('pincode').value == ''
                ">Pincode is required
              </span>
              <span class="passError" *ngIf="
                  myForm.get('pincode').invalid &&
                  myForm.get('pincode').value != ''
                ">Pincode is not valid
              </span>

              <div class="inputGroup">
                <mat-form-field class="w-100 mat-input-group" appearance="outline">
                  <mat-label class="matLabel">City</mat-label>
                  <mat-select formControlName="cityId" (closed)="clearFilterCityOptions()">
                    <div class="inputSearchBox">
                      <input class="inputSearch" placeholder="Search" (input)="filterCityOptions($event)"
                        formControlName="citySearch" (ng-keydown)="stopSpaceSelect($event)" />
                      <div class="inserchbox">
                        <img src="assets/images/Search.svg" alt="" />
                      </div>
                    </div>
                    <mat-option [value]="" *ngIf="!filteredCity.length">----City not found----</mat-option>
                    <mat-option [value]="city.id" *ngFor="let city of filteredCity">{{ city.name }}</mat-option>
                  </mat-select>
                </mat-form-field>
                <span class="passError" *ngIf="
                    myForm.get('cityId') &&
                    myForm.get('cityId').required &&
                    myForm.get('cityId').touched
                  ">Please Enter City</span>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="inputGroup">
                <textarea id="personalAddress" formControlName="registeredAddress" rows="8" placeholder=""
                  class="inputBox regTextarea contareaheight"></textarea>
                <label for="personalAddress" class="inputLabel">Personal Address</label>
              </div>
              <span class="passError" *ngIf="getValid('registeredAddress')">Please fill personal address
              </span>
            </div>
            <div class="col-lg-6">
              <div class="inputGroup">
                <mat-form-field class="w-100 mat-input-group" appearance="outline">
                  <mat-label class="matLabel">State2</mat-label>
                  <mat-select formControlName="stateId" (closed)="clearFilterOptions()">
                    <div class="inputSearchBox">
                      <input class="inputSearch" placeholder="Search" formControlName="stateSearch"
                        (input)="filterOptions($event)" (ng-keydown)="stopSpaceSelect($event)" />
                      <div class="inserchbox">
                        <img src="assets/images/Search.svg" alt="" />
                      </div>
                    </div>
                    <mat-option [value]="" *ngIf="!filteredState.length">----State not found----</mat-option>
                    <mat-option [value]="state.id" *ngFor="let state of filteredState">{{ state.name }}</mat-option>
                  </mat-select>
                </mat-form-field>

                <span class="passError" *ngIf="
                    myForm.get('state') &&
                    myForm.get('state').required &&
                    myForm.get('state').touched
                  ">Please Enter State</span>
              </div>
            </div>
          </div>
        </div>

        <app-main-heading [title]="title2"></app-main-heading>
        <div class="document-validation-page">
          <div class="documents card-width">
            <div class="document-type customScroll">
              <ngx-slick-carousel [config]="carouselConfig" #carousel1 class="carousel">
                <div ngxSlickItem class="carousel-item" class="doc-type-btn {{
                    this.selectedFile.value == document.value ? 'active' : ''
                  }}" *ngFor="let document of validationDocuments.businessDocs"
                  (click)="changeDocument(document)">
                  {{ document.legalDocumentName }}
                </div>
              </ngx-slick-carousel>
            </div>
            <div class="document-image" *ngIf="this.selectedFile.value">
              <div class="img-magnifier-container">
              <img class="docFullImage"
              id="myimage"
              *ngIf="
                  this.selectedFile.value.substr(
                    this.selectedFile.value.length - 4
                  ).toLowerCase() == 'jpeg' ||
                  this.selectedFile.value.substr(
                    this.selectedFile.value.length - 3
                  ).toLowerCase() == 'png' ||
                  this.selectedFile.value.substr(
                    this.selectedFile.value.length - 3
                  ).toLowerCase() == 'jpg'
                "
                width="600" height="400"
                [src]="this.selectedFile.value" alt="your image" />
              </div>

                <!-- <div class="img-magnifier-container">
                  <img id="myimage" src="https://loremflickr.com/1200/800" width="600" height="400">
                </div> -->

              <!-- <embed class="docFullImage" *ngIf="
                  this.selectedFile.value.substr(
                    this.selectedFile.value.length - 3
                  ) == 'pdf'
                " [src]="
                  this.sanitizer.bypassSecurityTrustResourceUrl(
                    selectedFile.value
                  )
                " style="width: 100%; height: 500px" type="application/pdf" /> -->

              <!-- <iframe class="docFullImage" *ngIf="
                  this.selectedFile.value.substr(
                    this.selectedFile.value.length - 3
                  ) == 'doc' ||
                  this.selectedFile.value.substr(
                    this.selectedFile.value.length - 4
                  ) == 'docx'
                " [src]="
                  this.sanitizer.bypassSecurityTrustResourceUrl(
                    openDocViewURl()
                  )
                " width="100%" height="500px" frameborder="0"></iframe> -->

                <ngx-doc-viewer
                [googleCheckInterval] = 10000
                *ngIf="
                  this.selectedFile.value.substr(
                    this.selectedFile.value.length - 3
                  ).toLowerCase() == 'doc' ||
                  this.selectedFile.value.substr(
                    this.selectedFile.value.length - 4
                  ).toLowerCase() == 'docx' ||
                  this.selectedFile.value.substr(
                    this.selectedFile.value.length - 3
                  ).toLowerCase() == 'pdf'
                "
                 [url]="this.selectedFile.value"
                 viewer="google"
                 style="width:100%;height: 500px;"
                 ></ngx-doc-viewer>
            </div>
          </div>
          <div class="document-detail">
            <div class="row g-2 g-lg-4">
              <div class="col-lg-6 col-6">
                <div class="inputGroup">
                  <div class="inputGroupInput">
                    <select name="preSalutationId" id="preSalutationId" class="regSelect"
                      value="{{ myForm.get('salutationId').value }}" disabled="true">
                      <option value="2">Miss</option>
                      <option value="1">Mrs</option>
                    </select>
                    <div class="inputGroupInner">
                      <input onkeydown="return /[a-z ]/i.test(event.key)" value="{{ myForm.get('firstName').value }}"
                        disabled="true" type="text" id="name2" class="inputBox" placeholder="" />
                      <label for="name2" class="inputLabel">First Name</label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-6 col-6">
                <div class="inputGroup">
                  <input onkeydown="return /[a-z ]/i.test(event.key)" type="text"
                    value="{{ myForm.get('lastName').value }}" disabled="true" class="inputBox" id="lastName2"
                    placeholder="" />
                  <label for="lastName2" class="inputLabel">Last Name</label>
                </div>
              </div>
              <!-- <div formArrayName="businessDoc">
                <div *ngFor="let document of myForm.get('businessDoc').controls; let i = index" [formGroupName]="i">
                  <div *ngIf="selectedFile.id == document.get('id').value">
                    <div class="row align-items-center">
                      <div class="col-lg-8" style="margin-bottom: 25px; ">
                        <div class="document-acceptence">
                          <div class="accptence-text">Document Acceptance</div>
                          <label class="switch">
                            <input type="checkbox" id="togBtn" (change)="validDocumentAcceptance1($event, i)" formControlName="docAcceptance" />
                            <div class="slider round">
                              <span class="on">YES</span>
                              <span class="off">NO</span>
                            </div>
                          </label>
                        </div>
                      </div>
                      <div class="col-lg-4" *ngIf="!document.get('docAcceptance').value">
                        <div class="inputGroup">
                          <mat-form-field class="w-100 mat-input-group" appearance="outline">
                            <mat-label class="matLabel">Select Reason</mat-label>
                            <mat-select formControlName="selectReasonDropDown" (selectionChange)="
                                updateSelectReason($event.value, i)
                              " [disabled]="persentMode == 0 ? true : false">
                              <mat-option [value]="reason.id" *ngFor="let reason of reasonArray">{{ reason.name
                                }}</mat-option>
                            </mat-select>
                          </mat-form-field>
                          <span class="passError" *ngIf="this.getDocuments.at(i).get('reasons')?.invalid && !isValid">
                            *Reason is required
                          </span>
                        </div>
                      </div>
                    </div> -->
                    <div formArrayName="businessDoc">
                      <div *ngFor="let document of myForm.get('businessDoc').controls; let i = index" [formGroupName]="i">
                        <div *ngIf="selectedFile.id == document.get('id').value">
                          <!-- Add more fields as needed -->
                          <div class="row align-items-center">
                            <div class="col-lg-8" style="margin-bottom: 25px;">
                              <div class="document-acceptence">
                                <div class="accptence-text">Document Acceptance</div>
                                <label class="switch">
                                  <input type="checkbox" id="togBtn" (change)="validDocumentAcceptance1($event, i)" formControlName="docAcceptance" />
                                  <div class="slider round">
                                    <span class="on">YES</span>
                                    <span class="off">NO</span>
                                  </div>
                                </label>
                              </div>
                            </div>
                            <div class="col-lg-4" *ngIf="!document.get('docAcceptance').value">
                              <div class="inputGroup">
                                <mat-form-field class="w-100 mat-input-group" appearance="outline">
                                  <mat-label class="matLabel">Select Reason</mat-label>
                                  <mat-select formControlName="selectReasonDropDown" (selectionChange)="updateSelectReason($event.value, i)" [disabled]="persentMode == 0 ? true : false">
                                    <mat-option [value]="reason.id" *ngFor="let reason of reasonArray">{{ reason.name }}</mat-option>
                                  </mat-select>
                                </mat-form-field>
                                <span class="passError" *ngIf="this.getDocuments.at(i).get('reasons')?.invalid && !isValid">
                                  *Reason is required
                                </span>
                              </div>
                            </div>
                          </div>





                    <div *ngIf="document.get('docAcceptance').value">
                      <div formArrayName="docAcceptanceArray">
                        <div class="row align-items-center pp" *ngFor="
                            let acceptanceItem of document.get(
                              'docAcceptanceArray'
                            ).controls;
                            let j = index
                          " [formGroupName]="j">
                          <div class="col-lg-8" *ngIf="acceptanceItem.get('type').value == 'TEXT'">
                            <label for="" class="label-1">{{acceptanceItem.get('label').value}}</label>
                            <div class="inputGroup">

                              <div class="inputGroupInner">
                                <input onkeydown="return /[a-z ]/i.test(event.key)" type="text" [disabled]="true"
                                  id="bussinesNamePan" class="inputBox" formControlName="value" placeholder="" />
                                <label for="panCar" class="inputLabel">{{ acceptanceItem.get("type").label }}
                                </label>
                                <span class="passError" *ngIf="
                                    acceptanceItem.get('value') &&
                                    acceptanceItem.get('value')
                                      .required &&
                                    acceptanceItem.get('value').touched
                                  ">Please Enter State</span>
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-8" *ngIf="acceptanceItem.get('type').value == 'DATE'">
                            <label for="" class="label-1">{{acceptanceItem.get('label').value}}</label>
                            <div class="inputGroup">

                              <mat-form-field class="w-100 mat-input-group" appearance="outline">
                                <input matInput [disabled]="true" [matDatepicker]="picker" [max]="today" placeholder=" "
                                  formControlName="value" max />
                                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                <mat-datepicker #picker startView="year"></mat-datepicker>
                              </mat-form-field>
                              <label for="value" class="inputLabel">{{
                                acceptanceItem.get("type").lable }}</label>
                              <span class="passError" *ngIf="
                                  acceptanceItem.get('value') &&
                                  acceptanceItem.get('value')
                                    .invalid &&
                                    acceptanceItem.get('value')
                                    .touched
                                ">Please Select Business Incorporation Date</span>
                            </div>
                          </div>
                          <div class="col-lg-4">
                            <div class="inputGroup">
                              <mat-form-field class="w-100 mat-input-group" appearance="outline">
                                <mat-label class="matLabel">Select</mat-label>
                                <mat-select formControlName="statusId" (selectionChange)="validDocumentAcceptance()">
                                  <mat-option [value]="reason.id" *ngFor="let reason of docStatusList">
                                    {{ reason.name }}
                                  </mat-option>
                                </mat-select>
                              </mat-form-field>
                            </div>
                          </div>
                          <!-- Add more fields as needed -->
                        </div>
                      </div>
                      <!-- <div>
                        <div class="col-lg-8">
                          <div class="document-acceptence">
                            <div class="accptence-text">Expiry Date</div>
                            <label class="switch">
                              <input type="checkbox" id="togBtn" formControlName="expiryDateTogel" [checked]="isChecked(document.get('documentExpiryDate').value)"  />
                              <div class="slider round">
                                <span class="on">YES</span>
                                <span class="off">NO</span>
                              </div>
                            </label>
                          </div>
                        </div>
                        <div class="inputGroup" *ngIf="document.get('expiryDateTogel').value">
                          <mat-form-field class="w-100 mat-input-group" appearance="outline">
                            <input matInput [matDatepicker]="picker" (click)="picker.open()" placeholder=""
                              formControlName="documentExpiryDate" />
                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-datepicker #picker startView="year"></mat-datepicker>
                          </mat-form-field>
                          <label for="documentExpiryDate" class="inputLabel">Expiry Date</label>
                        </div>
                      </div> -->


                      <div>
                        <div class="col-lg-8">
                            <div class="document-acceptance expiredate">
                                <div class="acceptance-text">Expiry Date</div>
                                <label class="switch">
                                    <input type="checkbox" formControlName="expiryDateTogel" (change)="expireDateOnChange($event, i)"/>
                                    <div class="slider round">
                                        <span class="on">YES</span>
                                        <span class="off">NO</span>
                                    </div>
                                </label>
                            </div>
                        </div>
                        <!-- <div class="inputGroup" *ngIf="document.get('expiryDateTogel').value">
                            <mat-form-field class="w-100 mat-input-group" appearance="outline" [ngClass]="{ 'has-error': document.get('documentExpiryDate').invalid }">
                                <input matInput [matDatepicker]="picker" placeholder="Expiry Date"
                                    formControlName="documentExpiryDate" />
                                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                <mat-datepicker #picker></mat-datepicker>
                                <mat-error *ngIf="document.get('documentExpiryDate').hasError('required')">Expiry Date is required</mat-error>
                            </mat-form-field>
                        </div> -->
                        <div class="inputGroup" *ngIf="document.get('expiryDateTogel').value">
                          <mat-form-field class="w-100 mat-input-group" appearance="outline" [ngClass]="{ 'has-error': document.get('documentExpiryDate').invalid }">
                              <input matInput [matDatepicker]="picker" placeholder="Expiry Date"
                                  formControlName="documentExpiryDate" (dateChange)="expireDateChange($event, i)" (focus)="openDatePicker(picker)"  />
                              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                              <mat-datepicker #picker></mat-datepicker>
                              <!-- Error message -->
                              <!-- <mat-error *ngIf="expireDateError">Expiry Date is required</mat-error> -->
                          </mat-form-field>
                          <span class="passError" *ngIf="getDocuments.at(i).get('documentExpiryDate')?.invalid && !isValid">
                            *Expiry Date is required
                          </span>
                      </div>

                    </div>




                    </div>
                    <ng-template [ngIf]="getSelectedReason(i, 'selectReasonDropDown') == 5">
                      <div class="col-lg-12">
                        <div class="inputGroup">
                          <textarea id="otherReson" formControlName="reasons" rows="8" placeholder=""
                            maxlength="500" class="inputBox regTextarea remarkreaheight"></textarea>
                          <label for="addreg" class="inputLabel">Enter Reason</label>
                          <span class="passError" *ngIf="
                          document &&
                          document.hasError('required') &&
                          document.get('reasons').touched
                            ">Please Enter Reason</span>
                        </div>
                      </div>
                    </ng-template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>



        <div formArrayName="businessDoc">
          <div *ngFor="let document of myForm.get('businessDoc').controls; let i = index" [formGroupName]="i">
            <!-- <div *ngIf="isPriority && selectedFile.id == document.get('id').value"> -->
            <div *ngIf="selectedFile.id == document.get('id').value">
              <div class="remark">
                <h3 class="reason remarkTitle">Remarks/Comments</h3>
                <div class="row">
                  <div class="col-lg-12">
                    <div class="inputGroup">
                      <textarea id="remarks{{i}}" formControlName="remarks" rows="8" placeholder="" class="inputBox regTextarea remarkreaheight"></textarea>
                      <label for="remarks{{i}}" class="inputLabel">Enter remarks.....</label>
                    </div>
                    <!-- <span class="passError" *ngIf="document.get('remarks').errors && document.get('remarks').touched">Please Enter Reason</span> -->
                  </div>
                </div>
              </div>
              <!-- <div class="reasons" *ngIf="document.get('selectReasonDropDown').value == 5">
                <h3 class="reason">Reasons</h3>
                <ol class="resonsList" style="list-style-type: none;">
                  <li>{{ getSelectedReason(i, 'reasons') }}</li>
                </ol>
              </div> -->
              <div>
                <!-- <div class="reasons">
                  <h3 class="reason">Reasons</h3>
                  <ol type="1">
                    <li>Lorem ipsum dolor sit amet consectetur.</li>
                    <li>In elit sem pellentesque morbi adipiscing urna malesuada proin.</li>
                    <li>A dictumst non nulla a enim arcu non.</li>
                    <li>Velit cursus tristique netus odio bibendum blandit. Justo commodo dignissim est vitae.</li>
                  </ol>
                </div> -->
              </div>
            </div>
          </div>
        </div>



        <div *ngIf="isPriority">
          <div class="seller-categories-box">
            <div class="seller-category">
              <div class="row g-2 g-lg-4">
                <div class="col-lg-3 col-4">
                  <div class="seller-category-title">Map Category :</div>
                </div>
                <div class="col-lg-8 col-6">
                  <div class="inputGroup">
                    <mat-form-field class="w-100 mat-input-group" appearance="outline">
                      <mat-label class="matLabel">Map Category </mat-label>
                      <mat-select formControlName="proCategory" (selectionChange)="selectMainCategory($event)">
                        <mat-option [value]="reason.id" *ngFor="let reason of proCategoryList">{{ reason.name }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <span class="passError" *ngIf="
                  myForm.get('proCategory') &&
                  myForm.get('proCategory').hasError('required') &&
                  myForm.get('proCategory')?.touched
                ">Please Select Map Category</span>
                </div>
                <div class="col-lg-3 col-4">
                  <div class="seller-category-title">Map Sub - Category :</div>
                </div>
                <div class="col-lg-8 col-6">
                  <div class="inputGroup">
                    <mat-form-field class="w-100 mat-input-group" appearance="outline">
                      <mat-label class="matLabel">Map Sub - Category
                      </mat-label>
                      <mat-select formControlName="subCategory">
                        <mat-option [value]="reason.id" *ngFor="let reason of subCategoryList">{{ reason.name }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <span class="passError" *ngIf="
                  myForm.get('subCategory') &&
                  myForm.get('subCategory').hasError('required') &&
                  myForm.get('subCategory').touched
                ">Please Select Map Sub - Category</span>
                </div>
                <div class="col-lg-3 col-4">
                  <div class="seller-category-title">Map Business type :</div>
                </div>
                <div class="col-lg-8 col-6">
                  <div class="inputGroup">
                    <mat-form-field class="w-100 mat-input-group" appearance="outline">
                      <mat-label class="matLabel">Map Business type </mat-label>
                      <mat-select formControlName="mapBusinessType">
                        <mat-option [value]="reason.id" *ngFor="let reason of mapBusinesstype">{{ reason.name }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <span class="passError" *ngIf="
                  myForm.get('mapBusinessType') &&
                  myForm.get('mapBusinessType').hasError('required') &&
                  myForm.get('mapBusinessType').touched
                ">Please Select Map Business type</span>
                </div>
                <div class="col-lg-3 col-4">
                  <div class="seller-category-title">Display Name :</div>
                </div>
                <div class="col-lg-8 col-6">
                  <div class="inputGroup">
                    <mat-form-field class="w-100 mat-input-group" appearance="outline">
                      <mat-label class="matLabel">Display Name</mat-label>
                      <input type="text" matInput formControlName="displayName">
                    </mat-form-field>
                  </div>
                  <span class="passError" *ngIf="
                  myForm.get('displayName') &&
                  myForm.get('displayName').hasError('required') &&
                  myForm.get('displayName').touched
                ">Display name is required</span>
                </div>
              </div>
            </div>
          </div>

        </div>

        <div class="reason-btn-box mt-3">
          <!-- <div class="inputGroup">
            <mat-form-field class="w-100 mat-input-group" appearance="outline">
              <mat-label class="matLabel">Select Status</mat-label>
              <mat-select formControlName="selectStatus">
                <mat-option [value]="item.toStatusId" *ngFor="let item of businessWorkFlow">{{ item.toStatus
                  }}</mat-option>
              </mat-select>
            </mat-form-field>


          </div>   -->

<!-- {{persentMode}} - {{showAfterContent}} - {{businessWorkFlow.length}} -->

          <div *ngIf="persentMode == 1 && showAfterContent">
            <div class="dttbx">
              <c-dropdown *ngIf="businessWorkFlow.length > 0">
                <select formControlName="selectStatus" class="valbtn-blue-outline" (change)="selectStatusClick($event)">
                  <option value="" disabled selected>Select Status</option>
                  <option *ngFor="let item of businessWorkFlow" [value]="item.toStatusId" >
                    {{ item.toStatus }}
                  </option>
                </select>
              </c-dropdown>
            </div>
            <div class="passError text-start" style="margin: 15px 0px;">
              <div class="passError"  *ngIf="
                  myForm.get('selectStatus')?.hasError('required') &&
                  myForm.get('selectStatus')?.touched
                ">
                  Please Select Status
              </div>
            </div>
            <div class="btn-algn" style="margin-bottom: 150px;">
              <button class="valbtn-red" (click)="goBack()">
                Cancel
              </button>
              <button class="valbtn-blue" *ngIf="showSubmit() || businessWorkFlow.length > 0" (click)="updateValidationDetail()">
                Submit
              </button>
            </div>
          </div>



          <!-- <div class="dttbx" *ngIf="persentMode == 1 && showAfterContent">
            <c-dropdown *ngIf="businessWorkFlow.length > 0">
              <button cButton cDropdownToggle class="valbtn-blue-outline">
                {{selectStatusTitle}}
              </button>
              <div cDropdownMenu class="val-dropbx">
                <button cDropdownItem class="val-dropbx-item" formControlName="selectStatus" [value]="item.toStatusId"
                  *ngFor="let item of businessWorkFlow" (click)="selectStatusClick(item)">{{ item.toStatus
                  }}</button>
              </div>
              <div>
                <span class="passError" *ngIf="
                  myForm.get('selectStatus') &&
                  myForm.get('selectStatus')?.hasError('required') &&
                  myForm.get('selectStatus')?.touched
              ">Please Select Status</span>
              </div>
            </c-dropdown>
            <button class="valbtn-blue" *ngIf="showSubmit() || businessWorkFlow.length > 0" (click)="updateValidationDetail()"> Submit </button>
          </div> -->

        </div>

        <!-- <div class="reason-btn-box mt-3">
          <div class="reasonButtons">
            <div class="reason-btn res-orange" *ngIf="businessWorkFlowReject.length > 0"
              (click)="updateValidationDetail(businessWorkFlowReject[0])">
              Reject
            </div>
            <div class="follow_up_btn-box" *ngIf="businessWorkFlowFOLLOW.length > 0">
              <div class="reason-btn res-orange" (click)="togglefollowup()">
                Follow up
              </div>

              <div class="{{ followup ? 'followup_drop show' : 'followup_drop' }}">
                <div class="followup_drop-content">
                  <div *ngFor="let followUp of businessWorkFlowFOLLOW" (click)="updateValidationDetail(followUp)">
                    <div class="followup_btn">{{followUp.toStatus}}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="esclate_btn-box" *ngIf="businessWorkFlowESCALATE.length > 0">
              <div class="reason-btn res-yellow" (click)="toggleesclate()">
                Escalate
              </div>
              <div class="{{ esclate ? 'escalate_drop show' : 'escalate_drop' }}">
                <div class="escalate_drop-content">
                  <div *ngFor="let escalate of businessWorkFlowESCALATE" (click)="updateValidationDetail(escalate)">
                    <div class="escalate_btn">{{escalate.toStatus}}</div>
                  </div>
                </div>
              </div>
            </div>
            <button class="reason-btn res-green" *ngIf="businessWorkFlowApproved.length > 0"
              (click)="updateValidationDetail(businessWorkFlowApproved[0])">Approve</button>
          </div>
        </div> -->


      </form>
    </div>
  </div>
</div>



<ng-template #loader>
  <div class="shimmertext">
    <span class="loader"></span>
  </div>
</ng-template>
